var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.layout,_vm._b({tag:"component"},'component',_vm.layoutProps,false),[_c('router-view',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var Component = ref.Component;
var route = ref.route;
return [_c('transition',{attrs:{"name":route.meta && route.meta.transition}},[_c(Component,{tag:"component"})],1)]}}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }